import { drawImageOnCanvas } from "../../../Syntess.Web.Shared/Utils/ImageUtils";

// Binding handler om het canvas te vullen.
export class CanvasBindingHandler implements KnockoutBindingHandler {
    public update(element: HTMLCanvasElement, valueAccessor: () => any, allBindings: KnockoutAllBindingsAccessor) {
        let value = ko.unwrap(valueAccessor());
        if (typeof value === "string" && value.length > 0) {
            let img = document.createElement("img");
            img.onload = function () {
                drawImageOnCanvas(element, img, allBindings.get('maxWidth'), allBindings.get('maxHeight'), allBindings.get('enlarge'));
            };
            img.src = value;
        }
    }
}
